import withRouter from "components/Common/withRouter";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "components/Common/BreadcrumbTitle";

//redux
import CommonDialog from "components/Common/CommonDialog";
import ToastDialog from "components/Common/ToastDialog";
import { addRole } from "http/fundLync/role.helper";
import { useToast } from "ToastStore";
import { decryptedValue } from "common/utility";

const AddRole = (props) => {
  document.title = "Role | FundLync";
  const user = decryptedValue(localStorage.getItem("user"));
  const navigate = useNavigate();
  
  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [toastInfo, setToastInfo] = useState({ showToast: false });

  const { handleToastData } = useToast();
  // validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      roleName: "",
      roleDesc: "",
      displayName: "",
      entityType: "",
    },
    validationSchema: Yup.object({
      roleName: Yup.string().required("Please Enter Permission Name"),
      roleDesc: Yup.string().required("Please Enter Role Description"),
      displayName: Yup.string().required("Please Enter Role Display Name"),
      entityType: Yup.string().required("Please Select Entity Type"),
    }),
    onSubmit: (values) => {
        console.log("object")
      setShowCommonDialog({
        isShow: true,
        message: "Are you sure want to submit Role?",
      });
    },
  });

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false });
      const { values } = validation;
      const updateCustomer = {
        roleName: values.roleName,
        roleDescription: values.roleDesc,
        displayName: values.displayName,
        entityType: values.entityType,
      };
      addRole(updateCustomer)
      .then((response)=>{
        if(response.status && response.code== 201){
          handleToastData(response.message, "success")
          navigate(`/${user.roleName}/roles`)
        }else{
          const { message } = response;
          setToastInfo({
            message: message,
            showToast: true,
            role: "error",
          });
        }
      })
      .catch((error)=>{
        console.log(error)
      })
    } else {
      setShowCommonDialog({ isShow: false });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="ADD ROLE" />
          <Row>
            <Col xs="12">
              <div>
                <div>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row>
                      <Col md="6" sm="12">
                        <Label className="form-label">Role Name*</Label>
                        <Input
                          name="roleName"
                          type="text"
                          placeholder="Insert Role Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.roleName || ""}
                          invalid={
                            validation.touched.roleName &&
                            validation.errors.roleName
                          }
                        />
                        {validation.touched.roleName &&
                        validation.errors.roleName ? (
                          <FormFeedback type="invalid">
                            {validation.errors.roleName}
                          </FormFeedback>
                        ) : null}
                      </Col>

                      <Col md="6" sm="12">
                        <Label className="form-label">
                          Role Description*
                        </Label>
                        <Input
                          name="roleDesc"
                          type="text"
                          placeholder="Insert Role Description"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.roleDesc || ""}
                          invalid={
                            validation.touched.roleDesc &&
                            validation.errors.roleDesc
                          }
                        />
                        {validation.touched.roleDesc &&
                        validation.errors.roleDesc ? (
                          <FormFeedback type="invalid">
                            {validation.errors.roleDesc}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col md="6" sm="12">
                        <Label className="form-label mt-2">
                          Role Display Name*
                        </Label>
                        <Input
                          name="displayName"
                          type="text"
                          placeholder="Insert Role Display Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.displayName || ""}
                          invalid={
                            validation.touched.displayName &&
                            validation.errors.displayName
                          }
                        />
                        {validation.touched.displayName &&
                        validation.errors.displayName ? (
                          <FormFeedback type="invalid">
                            {validation.errors.displayName}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col md="6" sm="12">
                        <Label className="form-label mt-2">Entity Type*</Label>
                        <Input
                          name="entityType"
                          type="select"
                          placeholder="Select Entity Type"
                          onChange={(e) => {
                            validation.handleChange(e);
                          }}
                          onBlur={validation.handleBlur}
                          value={validation.values.entityType || ""}
                          invalid={
                            validation.touched.entityType &&
                            validation.errors.entityType
                          }
                        >
                           <option value="" disabled>Select Entity Type</option>
                          <option value="Owner">Owner</option>
                          <option value="Customer">Customer</option>
                          <option value="Financier">Financier</option>
                        </Input>
                        {validation.touched.entityType &&
                          validation.errors.entityType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.entityType}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mt-4">
                        <div className="text-end">
                          <button
                            className="btn btn-outline-success save-customer me-3"
                            onClick={() => navigate(-1)}
                          >
                            Back
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success save-customer"
                          >
                            Save
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {showCommonDialog && (
        <CommonDialog
          isShow={showCommonDialog.isShow}
          message={showCommonDialog.message}
          data={showCommonDialog.data}
          postitiveBtn={"Submit"}
          negativeBtn={"Close"}
          onCloseFn={dialogAction}
        ></CommonDialog>
      )}
       <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default withRouter(AddRole);

AddRole.propTypes = {
  history: PropTypes.object,
};

